module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var innerRowCount = function (row) {
    var count = 1;
    var recurse = function (row) {
        if (row.hasOwnProperty("rows")&&_.isObject(row.rows)&&Object.keys(row.rows).length) {
            count += Object.keys(row.rows).length - 1;
            _.each(row.rows, function (row) {
                recurse(row);
            });
        }
        if (row.hasOwnProperty("total")&&_.isObject(row.rows)) {
            count ++;
        }
    };
    recurse(row);
    return count;
}

var innerColCount = function (cell) {
    var count = 1;
    var recurse = function (cell) {
        if (cell.hasOwnProperty("cols") && Object.keys(cell.cols).length) {
            count--;
            _.each(cell.cols, function (cell) {
                count ++
                if (_.isArray(cell) || _.isObject(cell)) {
                    recurse(cell);
                }
            });
        }
    };
    recurse(cell);
    return count;
}

var calcDeep = function (item, key, min = 0) {
    var deep = 0;
    var recurse = function (item, _deep) {
        if (_deep > deep) deep = _deep;
        if (item.hasOwnProperty(key) && Object.keys(item[key]).length) {
            _.each(item[key], function (item) {
                recurse(item, _deep+1);
            });
        }
    }
    recurse(item, deep+1);
    return deep>min?deep:min;
}

var calcDeepRows = function (data) {
    var cols = 0;
    var recurse = function (rows) {
    	if (rows.length) {
			var row = rows[0];

			if (row.fields && _.isArray(row.fields))
				cols += row.fields.length

			else if (row.fields && _.isObject(row.fields))
				cols += Object.keys(row.fields).length;

			if (row.rows && row.rows.length)
				recurse(row.rows);
		};

        // if (_deep > deep) deep = _deep;
        // _.each(items, function (item) {
        //     if (item.hasOwnProperty(key) && _.isObject(item[key]) && Object.keys(item[key]).length) {
        //         recurse(item[key], _deep+1);
        //     }
        // });
    }
    debugger
    recurse(data.rows);
    return cols - (_.isObject(data.total.fields)?Object.keys(data.total.fields).length:data.total.fields.length);
}

var rowWrite = function (row, tagName) {
    if (row.hasOwnProperty("fields") ) _.each(row.fields, function (field) { 
    ; __append("\n        <")
    ; __append(escapeFn(tagName))
    ; __append(" ")
    ;  if(tagName=='th') {
    ; __append(" style=\"background-color: #eeeeee;\"")
    ;  } 
    ; __append("\n        ")
    ;  if (_.isArray(field) || _.isObject(field)) {
            field = _.map( field, function ($v) {return $v}).join(' / ');
        } 
    ; __append("\n        ")
    ;  if(innerRowCount(row)>1) { 
    ; __append(" rowspan=\"")
    ; __append(escapeFn(innerRowCount(row)))
    ; __append("\"")
    ;  } 
    ; __append(">")
    ; __append(escapeFn(field))
    ; __append("</")
    ; __append(escapeFn(tagName))
    ; __append(">\n    ")
    ;  });
    if (row.hasOwnProperty("rows") && _.isObject(row.rows) && Object.keys(row.rows).length) {
        var first = true;
    if (row.hasOwnProperty("rows") && _.isObject(row.rows)) _.each(row.rows, function (row) {
    if (!first) { 
    ; __append("\n    </tr><tr>\n        ")
    ;  }
            rowWrite(row, 'td');
            first = false;
        });
    }
    if (row.hasOwnProperty("total") && Object.keys(row.total).length) { 
    ; __append("\n    </tr><tr>\n        <th colspan=\"")
    ; __append(escapeFn( calcDeepRows(row) ))
    ; __append("\" >&nbsp;</th>\n        ")
    ;  rowWrite(row.total, 'th'); 
    ; __append("\n    </tr><tr>\n        ")
    ; 
    }
};

var cellsWrite = function (cells, deep) {
    var nextRowCells = []; 
    ; __append("\n\n    ")
    ;  _.each(cells, function(cell) {
        if (_.isArray(cell) || _.isObject(cell)) {
			//if (cell.field) { 

    ; __append("\n            	<th deep=\"")
    ; __append(escapeFn( deep ))
    ; __append("\" sub=\"")
    ; __append(escapeFn( calcDeep(cell, 'cols', deep) ))
    ; __append("\"colspan=\"")
    ; __append(escapeFn( innerColCount(cell) ))
    ; __append("\"\n					rowspan=\"")
    ; __append(escapeFn( deep - calcDeep(cell, 'cols', deep)+1 ))
    ; __append("\">")
    ; __append(escapeFn( cell.field ))
    ; __append("</th>\n            ")
    ;  //}
            _.each(cell.cols, function(cell) {
                nextRowCells.push(cell);
            });
        } else { 
    ; __append("\n            <th rowspan=\"")
    ; __append(escapeFn( deep ))
    ; __append("\">")
    ; __append(escapeFn( cell ))
    ; __append("</th>\n        ")
    ; }
    });

    if (nextRowCells.length) {
		//if (cell.field) { 

    ; __append("\n        	</tr><tr>\n		")
    ;  //} 

    ; __append("\n        ")
    ;  cellsWrite(nextRowCells, deep-1);
    }
}

    ; __append("\n\n\n<style>\n    .gl-report__table thead th {\n        text-align: center;\n    }\n    .gl-report__table .center {\n        text-align: center;\n    }\n\n    .gl-report__table tbody td,\n    .gl-report__table tbody th {\n        text-align: right;\n    }\n    .gl-report__table .left {\n        text-align: left;\n        float: inherit;\n    }\n</style>\n\n<div class=\"wh100\">\n    <table class=\"gl-report__table width-regulator\">\n        <thead>\n        <tr>")
    ;  cellsWrite ([data.head], calcDeep(data.head, 'cols')); 
    ; __append("</tr>\n        </thead>\n\n        <tbody>\n            ")
    ;  _.each(data.rows, function (row) { 
    ; __append("\n                <tr>\n                    ")
    ;  rowWrite(row, 'td'); 
    ; __append("\n                </tr>\n            ")
    ;  }); 
    ; __append("\n                <tr>\n                    <th class=\"left\" colspan=\"")
    ; __append(escapeFn( calcDeepRows(data) ))
    ; __append("\">Итог</th>\n                    ")
    ;  rowWrite(data.total, 'th'); 
    ; __append("\n                </tr>\n        </tbody>\n    </table>\n</div>")
  }
  return __output.join("");

}